module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av504-c43d1db2bd5e8c32ae502a83a882afbe.jpg";